import React, { Component } from 'react';
import {
  Text, View, Dimensions, Platform, StyleSheet, ScrollView, TouchableOpacity,
} from 'react-native';
import { MealPlanWithMeals } from 'fitbeat.models';
import { translate } from 'react-i18next';
import Accordion from 'react-native-collapsible/Accordion';
import { connect } from 'react-redux';
import ShoppingListHeader from './ShoppingListHeader';
import ShoppingListEdit from './ShoppingListEdit';
import {
  BaseModal, toggleShoppingListEditModalVisible, AccordionHeaderShoppingList, LoadingModal,
} from '../../ui';
import Theme from '../../theme';
import { AppStateFocusedEvents, FormKeyboardSpacer } from '../../ui/components';
import ShoppingListFoodCategory from './ShoppingListFoodCategory';
import {
  nutritionTabSelected, setShoppingListSettings, setChecklistExclusions,
  unCheckAllShoppingListItems, toggleShoppingListItemCheckStatus, getMealPlan,
} from '../actions';
import { Icon, Button } from '../../components';
import { UserDataConsumer } from '../../utils';
import { scaleText, defaultScale } from '../../utils/scaling';

const { width } = Dimensions.get('window');
const isMobile = width <= 550;

type PlaceholderTypeWhenConvertedToTsx = any;

interface IProps {
  mealPlans: MealPlanWithMeals;
  // todo: add missing fields
}

interface IState {
  shoppingListItems: PlaceholderTypeWhenConvertedToTsx;
  accordianShoppingListData: PlaceholderTypeWhenConvertedToTsx;
  categoryItems: PlaceholderTypeWhenConvertedToTsx;
  initiallyActiveSection: boolean;
}

class ShoppingList extends Component<IProps, IState> {
  constructor(props) {
    super(props);
    const accordianShoppingListData = [];
    const categoryItems = [];
    const shoppingListItemsClone = JSON.parse(JSON.stringify(props.shoppingListItems));
    this.state = {
      shoppingListItems: shoppingListItemsClone,
      accordianShoppingListData,
      categoryItems,
      initiallyActiveSection: Platform.OS === 'web' ? 0 : -1,
    };
  }

  public async componentDidUpdate(prevProps) {
    if (prevProps.shoppingListItems !== this.props.shoppingListItems) {
      const shoppingListItemsClone = JSON.parse(JSON.stringify(this.props.shoppingListItems));
      await this.setState({
        shoppingListItems: shoppingListItemsClone,
      });
      this.createCategories();
    }
  }

  public componentDidMount() {
    this.createCategories();
    this.props.nutritionTabSelected('Shopping List');
  }

  public screenFocussed = () => {
    this.props.getMealPlan();
    this.props.nutritionTabSelected('Shopping List');
  };

  public shoppingListCategoryItems = (categoryItems, indexOfCategoryItems, title) => (
    <ShoppingListFoodCategory
      title={title}
      indexOfCategoryItems={indexOfCategoryItems}
      toggleShoppingListItem={this.toggleShoppingListItem}
      categoryItems={categoryItems}
    />
  );

  public renderHeader = (section, index, isActive) => (
    <AccordionHeaderShoppingList
      index={index}
      section={section}
      isActive={isActive}
      setActiveIndex={this.setActiveIndex}
      onPress={this.clearSubmitForm}
      numberOfItemsSelected={section.numberOfItemsSelected}
    />
  );

  public renderContent = (section) => (
    <View style={styles.content}>
      {section.content()}
    </View>
  );

  public setActiveIndex = (value) => {
    const that = this;
    setTimeout(() => {
      that.setState({ activeSection: value });
    }, 200);
  };

  public toggleShoppingListEditModal = () => {
    const { isShoppingListEditModalVisible } = this.props;
    this.props.toggleShoppingListEditModalVisible(!isShoppingListEditModalVisible);
  };

  public closeSettings = () => {
    this.props.toggleShoppingListEditModalVisible(false);
  };

  public toggleShoppingListItem = (indexOfCategory, indexOfCategoryItem, title) => {
    const { categoryItems, accordianShoppingListData, shoppingListItems } = this.state;
    const categoryItemsForToggle = categoryItems;
    const accordionDataToEdit = accordianShoppingListData;
    const shoppingListItemsChecked = !categoryItemsForToggle[indexOfCategory]
      [title][indexOfCategoryItem].isCheckedFromShoppingList;
    categoryItemsForToggle[indexOfCategory][title][indexOfCategoryItem]
      .isCheckedFromShoppingList = shoppingListItemsChecked;

    let count = 0;
    categoryItemsForToggle[indexOfCategory][title].forEach((ingredientItem) => {
      if (!ingredientItem.isCheckedFromShoppingList) {
        count += 1;
      }
      const accordionData = accordionDataToEdit.find((accItem) => accItem.title === title);
      const indexOfAccordionData = accordionDataToEdit.indexOf(accordionData);
      accordionDataToEdit[indexOfAccordionData].numberOfItemsSelected = count;
    });
    this.setState({ categoryItems: categoryItemsForToggle, accordianShoppingListData: accordionDataToEdit });
    this.props.toggleShoppingListItemCheckStatus(shoppingListItemsChecked);
    this.updateChecklist(this.state.shoppingListItems);
  };

  public getNumberOfMealsSelected = (UserMealInfo) => {
    let count = 0;
    UserMealInfo.forEach((dayMeals) => {
      dayMeals.forEach((meal) => {
        if (meal.isInShoppingList === true) {
          count += 1;
        }
      });
    });
    return count;
  };

  public createCategories = () => {
    const { shoppingListItems } = this.state;
    const { t } = this.props;
    let categoryList = [];

    shoppingListItems.forEach((element) => {
      if (categoryList.indexOf(element.category) === -1) {
        categoryList.push(element.category);
      }
    });

    categoryList = categoryList.map((item) => {
      const relatedIngredients = shoppingListItems.filter((element) => element.category === item);
      return { [item]: relatedIngredients };
    });

    const sectinsAccordion = [];
    categoryList.forEach((categoryListItem) => {
      const title = Object.keys(categoryListItem)[0];
      let count = 0;
      count = categoryListItem[title].filter((item) => item.isCheckedFromShoppingList === false).length;
      const accordionItem = {
        title,
        content: () => this.shoppingListCategoryItems(
          categoryListItem[title],
          categoryList.indexOf(categoryListItem),
          title,
        ),
        isLast: true,
        numberOfItemsSelected: count,
      };
      sectinsAccordion.push(accordionItem);
    });
    return this.setState({ accordianShoppingListData: sectinsAccordion, categoryItems: categoryList });
  };

  public unCheckAll = () => {
    const { shoppingListItems, accordianShoppingListData, categoryItems } = this.state;
    let allCheckShoppingListItems = shoppingListItems;
    const accordionDataToEdit = accordianShoppingListData;
    const categoryItemsToCount = categoryItems;
    allCheckShoppingListItems = allCheckShoppingListItems.map((element) => {
      element.isCheckedFromShoppingList = false;
      return element;
    });
    categoryItemsToCount.forEach((categoryListItem) => {
      const title = Object.keys(categoryListItem)[0];
      let count = 0;
      count = categoryListItem[title].filter((item) => item.isCheckedFromShoppingList === false).length;
      const accordionData = accordionDataToEdit.find((accItem) => accItem.title === title);
      const indexOfAccordionData = accordionDataToEdit.indexOf(accordionData);
      accordionDataToEdit[indexOfAccordionData].numberOfItemsSelected = count;
    });

    this.setState({ shoppingListItems: allCheckShoppingListItems, accordianShoppingListData: accordionDataToEdit });
    this.updateChecklist(allCheckShoppingListItems);
    this.props.unCheckAllShoppingListItems();
  };

  public updateMealPlan = (mealPlansEdit, servingCount) => {
    const { mealPlans, setShoppingListSettings } = this.props;
    mealPlans.mealSchedule = new Map(mealPlansEdit);
    setShoppingListSettings(mealPlans, servingCount);
  };

  public updateChecklist = (checklist) => {
    const { setChecklistExclusions } = this.props;
    const onlyCheckedIngredients = [];

    checklist.forEach((item) => {
      if (item.isCheckedFromShoppingList) {
        onlyCheckedIngredients.push(item.ingredientId);
      }
    });
    setChecklistExclusions(onlyCheckedIngredients);
  };

  public render() {
    const { mealPlans, isLoading } = this.props;
    const { t, isShoppingListEditModalVisible } = this.props;
    const { initiallyActiveSection, accordianShoppingListData, activeSection } = this.state;

    return (
      <>
        <AppStateFocusedEvents
          navigation={this.props.navigation}
          onScreenFocus={this.screenFocussed}
        />
        {isLoading && !mealPlans && <LoadingModal style={styles.loading} />}
        {!isLoading && mealPlans && (
          <ScrollView
            style={styles.scrollView}
          >
            <View style={styles.container}>
              <ShoppingListHeader
                toggleModal={this.toggleShoppingListEditModal}
                numberOfSelectedMeals={this.getNumberOfMealsSelected(
                  mealPlans.mealSchedule,
                )}
              />
              <View style={styles.unCheckContainer}>
                <TouchableOpacity onPress={this.unCheckAll}>
                  <View style={styles.uncheckTextContainer}>
                    <Icon
                      size={defaultScale(20)}
                      color={Theme.DARK_CHARCOAL}
                      name='ios-refresh'
                      iconStyle={{ fontFamily: Theme.Custom700 }}
                      style={styles.iconContainer}
                    />
                    <Text style={styles.uncheckText}>
                      {t('unCheckAll')}
                    </Text>
                  </View>
                </TouchableOpacity>
              </View>

              <View style={styles.accordionContainer}>
                <FormKeyboardSpacer>
                  <ScrollView keyboardShouldPersistTaps='handled'>
                    <View>
                      <Accordion
                        sections={accordianShoppingListData}
                        renderHeader={this.renderHeader}
                        renderContent={this.renderContent}
                        touchableComponent={TouchableOpacity}
                        activeSection={activeSection}
                        initiallyActiveSection={initiallyActiveSection}
                      />
                    </View>
                  </ScrollView>
                </FormKeyboardSpacer>
              </View>

              <BaseModal
                title={t('editShoppingList')}
                closeModal={this.closeSettings}
                useFullWidth={false}
                isModalVisible={isShoppingListEditModalVisible}
              >
                <View style={styles.modalContainer}>
                  <ShoppingListEdit
                    mealPlans={mealPlans.mealSchedule}
                    servingCount={mealPlans.shoppingListServingCount || 1}
                    updateMealPlan={this.updateMealPlan}
                    closeModal={this.closeSettings}
                  />
                </View>
              </BaseModal>
            </View>
          </ScrollView>
        )}
      </>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'column',
    backgroundColor: Theme.GREY_LIGHT,
  },
  scrollView: {
    flex: 1,
    backgroundColor: Theme.GREY_LIGHT,
  },
  uncheckText: {
    ...Theme.textStyle.small,
    fontSize: scaleText(12),
    alignSelf: 'center',
  },
  unCheckContainer: {
    borderBottomColor: Theme.GREY_LIGHT,
    borderBottomWidth: 1,
  },
  uncheckTextContainer: {
    flexDirection: 'row',
    alignSelf: 'flex-end',
    width: defaultScale(85),
    marginRight: isMobile ? defaultScale(5) : defaultScale(11),
    paddingVertical: defaultScale(5),
    justifyContent: 'center',
  },
  iconContainer: {
    lineHeight: defaultScale(30),
    paddingRight: defaultScale(4),
    alignSelf: 'center',
    paddingTop: defaultScale(4),
  },
  loading: {
    flex: 1,
    justifyContent: 'center',
    backgroundColor: Theme.WHITE,
  },
  modalContainer: {
    flex: 1,
    height: Platform.OS === 'web' ? '100vh' : 600,
    padding: 0,
    width: '100%',
  },
  headerTextStyle: {
    padding: isMobile ? 15 : 0,
    borderBottomWidth: isMobile ? null : 2,
  },
  bodyStyle: {
    padding: 0,
    ...Platform.select({
      web: {
        padding: defaultScale(15),
      },
    }),
  },
  heading: {
    ...Theme.textStyle.heading,
    color: Theme.GREY_MEDIUM,
    paddingBottom: 10,
    paddingTop: 10,
  },
  textContainer: {
    justifyContent: 'center',
  },
  bodyGroupButton: {
    flex: 1,
    flexDirection: 'row',
    paddingVertical: 10,
  },
  settingCheckboxContainer: {
    justifyContent: 'center',
  },
  bodyRadioButtonContainer: {
    // marginRight: 15,
  },

  footer: {
    flex: 1,
    alignContent: 'flex-end',
    justifyContent: 'flex-end',
    marginTop: 30,
    marginLeft: 8,
    marginRight: 8,
  },
});
const mapStateToProps = (state) => ({
  isShoppingListEditModalVisible: state.ui.shoppingListEditModalVisible,
  mealPlans: state.nutrition.mealPlans,
  shoppingListItems: state.nutrition.shoppingList || [],
  isLoading: state.nutrition.isLoading,
});

const mapDispatchToProps = (dispatch, ownProps) => {
  const { user: { nutritionService } } = ownProps;
  return {
    toggleShoppingListEditModalVisible: (visible) => dispatch(toggleShoppingListEditModalVisible(visible)),
    setShoppingListSettings: (mealPlanWithMeals, servingCount) => dispatch(
      setShoppingListSettings(nutritionService, mealPlanWithMeals, servingCount),
    ),
    setChecklistExclusions: (checklist) => dispatch(setChecklistExclusions(nutritionService, checklist)),
    unCheckAllShoppingListItems: () => dispatch(unCheckAllShoppingListItems()),
    toggleShoppingListItemCheckStatus: (itemIsChecked) => dispatch(toggleShoppingListItemCheckStatus(itemIsChecked)),
    nutritionTabSelected: (tabTitle) => dispatch(nutritionTabSelected(tabTitle)),
    getMealPlan: () => dispatch(getMealPlan(nutritionService)),
  };
};

ShoppingList = UserDataConsumer(connect(mapStateToProps, mapDispatchToProps)(ShoppingList));
export default translate(['nutrition'], { wait: true })(ShoppingList);
